import { render } from "./NewOrderInNext.vue?vue&type=template&id=0cd6c142&scoped=true"
import script from "./NewOrderInNext.vue?vue&type=script&lang=js"
export * from "./NewOrderInNext.vue?vue&type=script&lang=js"

import "./NewOrderInNext.vue?vue&type=style&index=0&id=0cd6c142&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd6c142"]])

export default __exports__